import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Emoji Picker Fill
 */

export default function EmojiPickerFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6ZM10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7ZM4.9168 9.22383C4.76428 8.99363 4.45402 8.93067 4.22382 9.08319C3.99363 9.23572 3.93066 9.54597 4.08318 9.77617C4.62792 10.5983 5.67567 11.6125 7.06961 11.9131C8.51359 12.2244 10.1866 11.7419 11.8747 9.83104C12.0575 9.62409 12.038 9.30811 11.831 9.12529C11.6241 8.94246 11.3081 8.96201 11.1253 9.16896C9.6134 10.8803 8.28639 11.1524 7.28038 10.9355C6.22432 10.7078 5.37207 9.91094 4.9168 9.22383Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
